// Search Trends — exact clone of the curated `F1supplement_search_trends_india.html`
// artifact. The file lives at /public/search-trends-india.html so CRA serves
// it verbatim with its Chart.js scripts intact; we embed it via iframe so
// every detail (Fraunces typography, serif headlines, comparative chart,
// per-category narrative) renders exactly as the user designed it.
import React, { useEffect, useRef, useState } from "react";

const SearchTrendsModule = () => {
  const iframeRef = useRef(null);
  const [height, setHeight] = useState(2400); // generous default; resized on load

  // Auto-fit the iframe to the embedded document's scrollHeight so the
  // outer HORIZON shell scrolls naturally instead of nesting scrollbars.
  useEffect(() => {
    const resize = () => {
      try {
        const doc = iframeRef.current?.contentDocument;
        if (doc?.documentElement) {
          const h = Math.max(
            doc.documentElement.scrollHeight,
            doc.body?.scrollHeight || 0,
          );
          if (h && Math.abs(h - height) > 4) setHeight(h);
        }
      } catch { /* same-origin only — guarded */ }
    };
    const t = setInterval(resize, 600);
    return () => clearInterval(t);
  }, [height]);

  return (
    <div data-testid="search-trends-module" className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
      <iframe
        ref={iframeRef}
        src="/search-trends-india.html"
        title="Supplement Search Trends · India · 5-Year View"
        style={{ width: "100%", height: `${height}px`, border: 0, display: "block" }}
        data-testid="search-trends-iframe"
        onLoad={() => {
          try {
            const doc = iframeRef.current?.contentDocument;
            if (doc?.documentElement) {
              setHeight(Math.max(doc.documentElement.scrollHeight, doc.body?.scrollHeight || 0));
            }
          } catch {}
        }}
      />
    </div>
  );
};

export default SearchTrendsModule;
